import { useEffect } from "react";
import { toast } from "sonner";
import { track } from "@/lib/analytics";
import { getDesktopBridge } from "@/lib/desktop";

const UPDATE_TOAST_ID = "desktop-update";

/** Desktop only: offers to restart once a new version has downloaded. */
export function DesktopUpdatePrompt() {
	useEffect(() => {
		const bridge = getDesktopBridge();
		if (!bridge) {
			return;
		}
		const show = (version: string) => {
			track("desktop_update.prompt_shown", { version });
			toast(`Pluck Studio ${version} is ready`, {
				id: UPDATE_TOAST_ID,
				description: "Restart to finish updating.",
				duration: Number.POSITIVE_INFINITY,
				action: {
					label: "Restart now",
					onClick: () => {
						track("desktop_update.restart_clicked", { version });
						bridge.installUpdate().catch(() => {
							toast.error("Could not install the update.");
						});
					},
				},
			});
		};
		const unsubscribe = bridge.onUpdateReady(show);
		bridge
			.pendingUpdate()
			.then((version) => {
				if (version) {
					show(version);
				}
			})
			.catch(() => {
				// No pending update.
			});
		return unsubscribe;
	}, []);
	return null;
}
